import { makeStyles } from '@fluentui/react-components';

export const useEditDisplayTemplatePageStyles = makeStyles({
  page: {
    display: 'flex',
    height: '100%',
  },
  editorContainer: {
    position: 'absolute', // workaround for the style issue from the footer
    top: '0',
    bottom: '0',
    width: '100%',
  },
});
